import React, {useState} from "react";
import { Box, Button, Stack } from "@mui/material";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SendIcon from '@mui/icons-material/Send';

const StepActions = ({ onNext, onPreview, onSave, isValid, showPreview = true, onBack, leftOffset = 0, nextLabel = "Next" }) => {
  // console.log("StepActions - isValid: ", isValid);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {

    if (isSaving) return;

    try {
      setIsSaving(true);

      if (onSave) {
        await onSave();
      }
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: leftOffset,   // ← dynamic, defaults to 0 for Step1
        right: 0,
        bgcolor: "#fff",
        borderTop: "1px solid #E5E7EB",
        py: 2,
        px: 4,
        zIndex: 1000,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      {/* Left side — Back button */}
      <Box>
        {onBack && (
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={onBack}
            sx={{
              textTransform: "none",
              borderRadius: "20px",
              color: "#374151",
              borderColor: "#E5E7EB",
              fontWeight: 600,
            }}
          >
            Back
          </Button>
        )}
      </Box>
      <Stack direction="row" spacing={2}>
        {showPreview && (
          <Button
            variant="outlined"
            startIcon={<RemoveRedEyeOutlinedIcon />}
            onClick={onPreview}
            sx={{
              textTransform: "none",
              borderRadius: "20px",
              color: "#374151",
              borderColor: "#E5E7EB",
              fontWeight: 600,
            }}
          >
            Preview
          </Button>
        )}
        <Button
          variant="outlined"
          startIcon={<SaveOutlinedIcon />}
          onClick={handleSave}
          disabled={isSaving}
          sx={{
            textTransform: "none",
            borderRadius: "20px",
            color: "#374151",
            borderColor: "#E5E7EB",
            fontWeight: 600,
          }}
        >
          {isSaving ? "Saving..." : "Save Draft"}
        </Button>
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={onNext}
          sx={{
            textTransform: "none",
            borderRadius: "20px",
            bgcolor: "#0369A1",
            fontWeight: 600,
            px: 3,
            '&:hover': { bgcolor: "#025a87" }
          }}
          disabled={!isValid}
        >
          {nextLabel}
        </Button>
      </Stack>
    </Box>
  );
};

export default StepActions;